<template>
  <div
    v-if="!loading && items.length"
    class="position-relative items"
    :style="about.img ? `background-image: url(${files + about.img})` : ''"
  >
    <v-sheet
      class="mx-auto py-10 py-md-13 py-lg-16 px-3"
      color="transparent"
      max-width="984px"
    >
      <div
        v-if="about.title"
        class="
          text-h6 text-md-h5 text-center
          font-weight-bold
          mb-6 mb-md-8
          items-title
          text-shadow
        "
      >
        {{ about.title }}
      </div>

      <v-sheet
        class="justify-space-around grid-list"
        color="transparent"
        width="100%"
      >
        <template v-for="(item, keyItems) in items">
          <StatisticsCard :key="keyItems" v-bind="item" />
        </template>
      </v-sheet>

      <div v-if="period.text" class="mt-10 mt-md-12">
        <div
          v-if="period.title"
          class="
            text-h6 text-md-h5 text-center
            font-weight-bold
            mb-3 mb-md-4
            items-title
            text-shadow
          "
        >
          {{ period.title }}
        </div>

        <div
          class="
            white--text
            text-body-1 text-center
            font-weight-bold
            text-shadow
          "
          v-html="period.text"
        ></div>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import StatisticsCard from "../cards/StatisticsCard.vue";

const _config = {
  mod: "statistics",
};

const _data = {
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  created() {
    const about = this.$rest("statisticsAbout").get({
      save: (state, data) => (state.item = data),
    });

    const statistics = this.$rest(_config.mod).get();

    const period = this.$rest("aboutStatisticsPeriod").get({
      save: (state, data) => (state.item = data),
    });

    Promise.all([about, statistics, period]).finally(
      () => (this.loading = false)
    );
  },
  computed: {
    about() {
      return this.$rest("statisticsAbout").item;
    },
    period() {
      return this.$rest("aboutStatisticsPeriod").item;
    },
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  components: {
    StatisticsCard,
  },
};
</script>

<style lang="scss" scoped>
.items {
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  &-title {
    color: #f7fa00;
  }

  .grid-list {
    display: grid;
    gap: 50px 0;
    grid-template-columns: repeat(2, minmax(0, auto));

    @media screen and (max-width: 599.9px) {
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
